import { useState } from "react";
import L from "leaflet";
import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from "react-leaflet";
// import { Link, Outlet } from 'react-router-dom';
import titikKumpul from "../data/titikkumpul.json";
import titikPengunsian from "../data/titik_pengungsian.json";
import genangan from "../data/genangan.json";

function Map() {
  console.log("titik kumpul", titikKumpul);
  const [center, setCenter] = useState([-8.720526, 116.849645]);
  const [tk, setTk] = useState(false);
  const [gen, setGen] = useState(false);

  return (
    <div className="flex">
      <div className="min-h-screen w-64 border-r bg-white">
        <div className="flex flex-col">
          <div className="border-b p-4 font-bold uppercase">Peta</div>
          <div className="mt-4 grid grid-cols-1 gap-2">
            <div
              className="flex cursor-pointer items-center px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
              onClick={() => setTk(!tk)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 384 512"
                className="mr-4 h-4 w-4"
                stroke="currentColor"
              >
                <path d="M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z" />
              </svg>
              Titik Kumpul & Evakuasi
            </div>

            {/* <div
              className="flex cursor-pointer items-center px-4 py-2 text-sm text-gray-600 hover:bg-gray-100"
              onClick={() => setGen(!gen)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                className="mr-4 h-4 w-4"
                stroke="currentColor"
              >
                <path d="M482.8 134.1C494 142.3 498.7 156.7 494.4 169.9C490.1 183.1 477.9 192 464 192H447.4L447.7 265.2C446.1 266.1 444.6 267.1 443.2 268.1C425.2 280.5 403 288.5 384 288.5C364.4 288.5 343.2 280.8 324.8 268.1C302.8 252.6 273.3 252.6 251.2 268.1C234 279.9 213.2 288.5 192 288.5C172.1 288.5 150.8 280.5 132.9 268.1C131.3 267 129.7 265.1 128 265V192H112C98.14 192 85.86 183.1 81.57 169.9C77.28 156.7 81.97 142.3 93.18 134.1L269.2 6.12C280.4-2.04 295.6-2.04 306.8 6.12L482.8 134.1zM269.5 309.9C280.6 302 295.4 302 306.5 309.9C328.1 325.4 356.5 336 384 336C410.9 336 439.4 325.2 461.4 309.9L461.5 309.9C473.4 301.4 489.5 302.1 500.7 311.6C515 323.5 533.2 332.6 551.3 336.8C568.5 340.8 579.2 358.1 575.2 375.3C571.2 392.5 553.1 403.2 536.7 399.2C512.2 393.4 491.9 382.6 478.5 374.2C449.5 389.7 417 400 384 400C352.1 400 323.4 390.1 303.6 381.1C297.7 378.5 292.5 375.8 288 373.4C283.5 375.8 278.3 378.5 272.4 381.1C252.6 390.1 223.9 400 192 400C158.1 400 126.5 389.7 97.5 374.2C84.12 382.6 63.79 393.4 39.27 399.2C22.06 403.2 4.854 392.5 .8426 375.3C-3.169 358.1 7.532 340.8 24.74 336.8C42.84 332.6 60.96 323.5 75.31 311.6C86.46 302.1 102.6 301.4 114.5 309.9L114.6 309.9C136.7 325.2 165.1 336 192 336C219.5 336 247 325.4 269.5 309.9H269.5zM461.4 421.9L461.5 421.9C473.4 413.4 489.5 414.1 500.7 423.6C515 435.5 533.2 444.6 551.3 448.8C568.5 452.8 579.2 470.1 575.2 487.3C571.2 504.5 553.1 515.2 536.7 511.2C512.2 505.4 491.9 494.6 478.5 486.2C449.5 501.7 417 512 384 512C352.1 512 323.4 502.1 303.6 493.1C297.7 490.5 292.5 487.8 288 485.4C283.5 487.8 278.3 490.5 272.4 493.1C252.6 502.1 223.9 512 192 512C158.1 512 126.5 501.7 97.5 486.2C84.12 494.6 63.79 505.4 39.27 511.2C22.06 515.2 4.853 504.5 .8422 487.3C-3.169 470.1 7.532 452.8 24.74 448.8C42.84 444.6 60.96 435.5 75.31 423.6C86.46 414.1 102.6 413.4 114.5 421.9L114.6 421.9C136.7 437.2 165.1 448 192 448C219.5 448 247 437.4 269.5 421.9C280.6 414 295.4 414 306.5 421.9C328.1 437.4 356.5 448 384 448C410.9 448 439.4 437.2 461.4 421.9H461.4z" />
              </svg>
              Daerah Terdampak Banjir
            </div>

            <div className="flex cursor-pointer items-center px-4 py-2 text-sm text-gray-600 hover:bg-gray-100">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                className="mr-4 h-4 w-4"
                stroke="currentColor"
              >
                <path d="M320 256C302.3 256 288 270.3 288 288C288 305.7 302.3 320 320 320H416C469 320 512 362.1 512 416C512 469 469 512 416 512H139.6C148.3 502.1 158.9 489.4 169.6 475.2C175.9 466.8 182.4 457.6 188.6 448H416C433.7 448 448 433.7 448 416C448 398.3 433.7 384 416 384H320C266.1 384 223.1 341 223.1 288C223.1 234.1 266.1 192 320 192H362.1C340.2 161.5 320 125.4 320 96C320 42.98 362.1 0 416 0C469 0 512 42.98 512 96C512 160 416 256 416 256H320zM416 128C433.7 128 448 113.7 448 96C448 78.33 433.7 64 416 64C398.3 64 384 78.33 384 96C384 113.7 398.3 128 416 128zM118.3 487.8C118.1 488 117.9 488.2 117.7 488.4C113.4 493.4 109.5 497.7 106.3 501.2C105.9 501.6 105.5 502 105.2 502.4C99.5 508.5 96 512 96 512C96 512 0 416 0 352C0 298.1 42.98 255.1 96 255.1C149 255.1 192 298.1 192 352C192 381.4 171.8 417.5 149.9 448C138.1 463.2 127.7 476.9 118.3 487.8L118.3 487.8zM95.1 384C113.7 384 127.1 369.7 127.1 352C127.1 334.3 113.7 320 95.1 320C78.33 320 63.1 334.3 63.1 352C63.1 369.7 78.33 384 95.1 384z" />
              </svg>
              Rute Evakuasi Terdekat
            </div> */}
          </div>
        </div>
      </div>
      <div className="flex-1">
        <MapContainer
          center={center}
          zoom={13}
          scrollWheelZoom={true}
          style={{ height: "100%" }}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {/* {titikKumpul &&
            titikKumpul.features.map((d, i) => (
              <Marker key={i} position={d.geometry.coordinates}>
                <Popup>
                  A pretty CSS3 popup. <br /> Easily customizable.
                </Popup>
              </Marker>
            ))} */}
          {tk && (
            <>
              <GeoJSON
                key="titik_kumpul"
                data={titikKumpul}
                pointToLayer={(feature, latlng) => {
                  const parkIcon = new L.Icon({
                    iconUrl: "/images/pin_titik_kumpul.png",
                    iconSize: [26, 35],
                    popupAnchor: [0, -15],
                    // shadowUrl: markerShadow,
                    // shadowAnchor: [13, 28],
                  });

                  return L.marker(latlng, {
                    icon: parkIcon,
                  });
                }}
                onEachFeature={(feature, layer) => {
                  // console.log("feature", feature);
                  layer.bindPopup(`<p>${feature.properties.KML_FOLDER}</p>`);
                }}
              />
              <GeoJSON
                key="titik_pengungsian"
                data={titikPengunsian}
                pointToLayer={(feature, latlng) => {
                  const parkIcon = new L.Icon({
                    iconUrl: "/images/pin_titik_pengungsian.png",
                    iconSize: [26, 35],
                    popupAnchor: [0, -15],
                    // shadowUrl: markerShadow,
                    // shadowAnchor: [13, 28],
                  });

                  return L.marker(latlng, {
                    icon: parkIcon,
                  });
                }}
                onEachFeature={(feature, layer) => {
                  // console.log("feature", feature);
                  layer.bindPopup(`<p>${feature.properties.NAME}</p>`);
                }}
              />
            </>
          )}
          {gen && <GeoJSON key="genangan" data={genangan} />}
        </MapContainer>
      </div>
    </div>
  );
}

export default Map;
